import { FC, ReactChild, useState } from 'react';
import styled from 'styled-components';
import { LocalizedText } from '@mews/framework';
import { Accordion } from '@optimus-web/core';

interface FAQAccordion {
    primaryTextKey: Mews.TextKey;
    body: ReactChild;
}

const AccordionWithTransparentBackground = styled(Accordion)`
    & [data-test-accordion-header] {
        background: transparent;
    }

    & [data-test-accordion-body] > div {
        background: transparent;
    }
`;

export const FAQAccordion: FC<FAQAccordion> = ({ primaryTextKey, body }) => {
    const [expanded, toggleExpand] = useState(false);
    const toggleHandler = () => toggleExpand((prevState: boolean) => !prevState);

    return (
        <AccordionWithTransparentBackground
            expanded={expanded}
            onClick={toggleHandler}
            title={<LocalizedText textKey={primaryTextKey} />}
            body={body}
            withBodyBorder
            bodyPadding="200"
        />
    );
};
